import React, { Fragment,useState,useEffect } from 'react';


const Loader = (props) => {

    // const [show, setShow] = useState(true);
    
    // useEffect(() => {
    //     const timeout = setTimeout(() => {
    //         setShow(false)
    //         },[3000]);

    //     return () => {
    //         clearTimeout(timeout);
    //         }
       
    // },[show]);

    return (
        <Fragment>
            <div className="loader-box">
                <div className="loader-1"></div>
            </div>
        </Fragment>
    );
}

export default Loader;